import SettingsGearshape from './SettingsGearshape';

export default SettingsGearshape;
